// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"1afd4dc8","33":"ea9b201e","64":"bdc4875a","93":"416f34e6","223":"46f182ff","453":"5df08128"}[chunkId] + ".chunk.js";
};